import ActionTypes from '../constants/ActionTypes';
import api from '../constants/api';
import { authHeader } from '../helpers';
import {history} from '../helpers'
import { postApi } from '../helpers/http';

export const requestDashboards = date => ({
  type: ActionTypes.REQUEST_DASHBOARD,
  date
})

export const receiveDashboards = (json) => ({
  type: ActionTypes.RECEIVE_DASHBOARD,
  items: json.data,
  receivedAt: Date.now()
})

const doFetchDashboards = (params) => async dispatch => {
  dispatch(requestDashboards());

  const data = {
    "process_type": "getDataMenu", 
    "datetime": params.datetime
  };

  try {
      const json = await postApi(data);
      if (json && json.statusCode != 200) {
          sessionStorage.removeItem('user');
          localStorage.removeItem('user');
          history.push('/index.html');
        }
        else {
          dispatch(receiveDashboards(json))
        };
      } catch (error) {
      console.error('Error:', error);
    };

  // return fetch(api.url, {
  //   method: 'POST',
  //   headers: authHeader(),
  //   body: JSON.stringify({"process_type": "getDataMenu", "datetime": params.datetime}),
  // })
  //   .then(response => response.json())
  //   .then(json => {
  //     // console.log('Success:', json.data);
  //     if (json && json.statusCode !== 200) {
  //       sessionStorage.removeItem('user');
  //       localStorage.removeItem('user');
  //       history.push('/index.html');
  //     }
  //     else {
  //       dispatch(receiveDashboards(json))
  //     }
  //   })
  //   .catch((error) => {
  //     console.error('Error:', error);
  //   });
}

export const fetchDashboards = (params) => (dispatch, getState) => {
  return dispatch(doFetchDashboards(params))
}
